import { useTranslation } from "react-i18next";

export const TitleComponent = () => {
	const [t] = useTranslation();

	document.title = t("pageTitle");

	return <></>;
};
